import React from 'react';
import type { SocialMediaType } from 'utils/socials';
import {
  ScopedSocialSharingData,
  ShareDropdown,
  ShareDropdownProps,
  toCopyLink,
  toSharable,
} from '../ShareDropdown';

const supportedShareTargets: SocialMediaType[] = ['twitter', 'telegram', 'reddit', 'facebook'];

export function GenericSharing({ openSeaLink, data, ...rest }: GenericShareDropdownProps) {
  return (
    <ShareDropdown
      {...rest}
      name="Share"
      sections={[[toCopyLink(openSeaLink.toString())], toSharable(supportedShareTargets, data)]}
    />
  );
}

export type GenericShareDropdownProps = Omit<ShareDropdownProps, 'name' | 'sections'> & {
  openSeaLink: URL;
  data: ScopedSocialSharingData;
};
